import ViewOptionEvent from '@adobe-fonts/site/events/ViewOptionEvent.js';

import { applyListView } from '../../../util/font_card_settings.ts';
import { updatePrefs } from '../../../util/user_prefs_util.js';

export function registerEventHandlers(element) {
  element.addEventListener(ViewOptionEvent.EVENT_NAME, event => handleViewOptionChange(event, element));
}

/**
 * Toggle the view of the elements between list and grid with data attribute `data-toggle-view`
 * Hide images when the view option is changed, and update the user prefs
 *
 * @param {ViewOptionEvent} event
 */
export function handleViewOptionChange(event, parent) {
  if (!(event instanceof ViewOptionEvent)) {
    return;
  }
  const isListView = event.detail.listView;
  applyListView(parent, isListView);

  updatePrefs({ selectedViewType: isListView ? 'list' : 'grid' });

  const imagesToggler = parent.querySelector('af-images-toggler');
  if (imagesToggler) {
    imagesToggler.toggleAttribute('disabled', isListView);
  }
}
